var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDocuments = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.907,
    height: 23.788,
    viewBox: "0 0 19.907 23.788",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "documents",
    transform: "translate(-594.642 -119.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_43",
    "data-name": "Groupe 43",
    transform: "translate(394 14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_888034",
    "data-name": 888034,
    transform: "translate(160.892 105.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_13",
    "data-name": "Groupe 13",
    transform: "translate(44.658 16.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_12",
    "data-name": "Groupe 12",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M137.164,344h-.776a.388.388,0,1,0,0,.776h.776a.388.388,0,1,0,0-.776Z",
    transform: "translate(-136 -344)",
    fill: "#5471a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15",
    "data-name": "Groupe 15",
    transform: "translate(46.987 16.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_14",
    "data-name": "Groupe 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M193.7,344h-9.315a.388.388,0,1,0,0,.776H193.7a.388.388,0,1,0,0-.776Z",
    transform: "translate(-184 -344)",
    fill: "#5471a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17",
    "data-name": "Groupe 17",
    transform: "translate(44.658 14.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_16",
    "data-name": "Groupe 16",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M137.164,296h-.776a.388.388,0,1,0,0,.776h.776a.388.388,0,1,0,0-.776Z",
    transform: "translate(-136 -296)",
    fill: "#5471a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_19",
    "data-name": "Groupe 19",
    transform: "translate(46.987 14.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_18",
    "data-name": "Groupe 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M193.7,296h-9.315a.388.388,0,1,0,0,.776H193.7a.388.388,0,1,0,0-.776Z",
    transform: "translate(-184 -296)",
    fill: "#5471a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21",
    "data-name": "Groupe 21",
    transform: "translate(44.658 12.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_20",
    "data-name": "Groupe 20",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M137.164,248h-.776a.388.388,0,0,0,0,.776h.776a.388.388,0,0,0,0-.776Z",
    transform: "translate(-136 -248)",
    fill: "#5471a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_23",
    "data-name": "Groupe 23",
    transform: "translate(46.987 12.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22",
    "data-name": "Groupe 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M193.7,248h-9.315a.388.388,0,0,0,0,.776H193.7a.388.388,0,0,0,0-.776Z",
    transform: "translate(-184 -248)",
    fill: "#5471a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_25",
    "data-name": "Groupe 25",
    transform: "translate(44.658 9.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_24",
    "data-name": "Groupe 24",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M137.164,200h-.776a.388.388,0,0,0,0,.776h.776a.388.388,0,0,0,0-.776Z",
    transform: "translate(-136 -200)",
    fill: "#5471a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_27",
    "data-name": "Groupe 27",
    transform: "translate(46.987 9.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_26",
    "data-name": "Groupe 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M193.7,200h-9.315a.388.388,0,0,0,0,.776H193.7a.388.388,0,0,0,0-.776Z",
    transform: "translate(-184 -200)",
    fill: "#5471a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_29",
    "data-name": "Groupe 29",
    transform: "translate(44.658 7.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_28",
    "data-name": "Groupe 28",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M137.164,152h-.776a.388.388,0,0,0,0,.776h.776a.388.388,0,0,0,0-.776Z",
    transform: "translate(-136 -152)",
    fill: "#5471a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_31",
    "data-name": "Groupe 31",
    transform: "translate(46.987 7.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_30",
    "data-name": "Groupe 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_17",
    "data-name": "Trac\\xE9 17",
    d: "M193.7,152h-9.315a.388.388,0,0,0,0,.776H193.7a.388.388,0,0,0,0-.776Z",
    transform: "translate(-184 -152)",
    fill: "#5471a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_33",
    "data-name": "Groupe 33",
    transform: "translate(40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_32",
    "data-name": "Groupe 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_18",
    "data-name": "Trac\\xE9 18",
    d: "M59.4,5.8a.367.367,0,0,0-.02-.1c0-.012-.007-.024-.013-.036a.388.388,0,0,0-.078-.114L53.858.114a.388.388,0,0,0-.114-.078c-.012-.005-.024-.009-.036-.013a.387.387,0,0,0-.1-.02c-.007,0-.014,0-.023,0H42.717a.388.388,0,0,0-.388.388V1.553H40.388A.388.388,0,0,0,40,1.941V22.9a.388.388,0,0,0,.388.388h16.3a.388.388,0,0,0,.388-.388V20.96h1.941a.388.388,0,0,0,.388-.388V5.822C59.407,5.814,59.4,5.806,59.4,5.8ZM53.973,1.325l4.109,4.109H53.973ZM56.3,22.512H40.776V2.329h1.553V20.571a.388.388,0,0,0,.388.388H56.3Zm2.329-2.329H43.105V.776H53.2V5.822a.388.388,0,0,0,.388.388h5.046Z",
    transform: "translate(-40)",
    fill: "#5471a9",
    stroke: "#5471a9",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_35",
    "data-name": "Groupe 35",
    transform: "translate(44.658 3.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_34",
    "data-name": "Groupe 34",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19",
    "data-name": "Trac\\xE9 19",
    d: "M138.717,72h-2.329a.388.388,0,0,0-.388.388v2.329a.388.388,0,0,0,.388.388h2.329a.388.388,0,0,0,.388-.388V72.388A.388.388,0,0,0,138.717,72Zm-.388,2.329h-1.553V72.776h1.553Z",
    transform: "translate(-136 -72)",
    fill: "#5471a9"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDocuments, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/documents.80b7105d.svg";
export { ForwardRef as ReactComponent };